import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardKpiService, InvoiceStatisticsChartComponent, SalesSummaryEntity, Timespan } from 'gung-dashboard';
import { ProductService } from 'gung-standard';
import { CultDashboardDataService } from '../../services/cult-dashboard-data.service';
import { first, forkJoin, mergeMap, of, takeUntil } from 'rxjs';
import { CultDashboardKpiService } from '../../services/cult-dashboard-kpi.service';

@Component({
    selector: 'cult-invoice-statistics-chart',
    templateUrl: './cult-invoice-statistics-chart.component.html',
    styleUrls: ['./cult-invoice-statistics-chart.component.scss'],
    standalone: false
})
export class CultInvoiceStatisticsChartComponent extends InvoiceStatisticsChartComponent implements OnInit {
  productCategories = [];
  productCategoryIds = [];
  public sortedLineChartLabels: string[];
  totals = {
    thisYear: [],
    lastYear: [],
    twelveMonthTotal: []
  };

  constructor(
    protected translateService: TranslateService, 
    protected dashboardKpiService: CultDashboardKpiService, 
    protected productService: ProductService,
    protected dashboardDataService: CultDashboardDataService
    ) {
    super(translateService, dashboardKpiService);
  }

  ngOnInit(): void {
    super.ngOnInit();
        
    this.productService.getListProducts().subscribe(p => {
      const uniqueCategories = new Map<string, any>();
  
      for (const product of p) {
        const categoryCode = product.extra.pim.productCategory.code;
        if (!uniqueCategories.has(categoryCode)) {
          uniqueCategories.set(categoryCode, product.extra.pim.productCategory);
        }
      }
  
      this.productCategories = Array.from(uniqueCategories.values());
    });
  }
  
  
  productCategorySelected(event) {
    this.loaded = false
    this.data = [];
    const currentDate = new Date();
    const lastYearEndDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());
    const lastYearStartDate = new Date(lastYearEndDate.getFullYear() - 1, lastYearEndDate.getMonth() +1, lastYearEndDate.getDate());

    const thisYearEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const thisYearStartDate = new Date(thisYearEndDate.getFullYear() - 1, thisYearEndDate.getMonth() +1, thisYearEndDate.getDate());

    const thisYearMonthRanges = [];
    const lastYearMonthRanges = [];

    let startDate = new Date(thisYearStartDate);

    while (startDate <= thisYearEndDate) {
      const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      thisYearMonthRanges.push({ fromDate: startDate, toDate: endDate });
      startDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);
    }
    startDate = new Date(lastYearStartDate);
    while (startDate <= lastYearEndDate) {
      const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      lastYearMonthRanges.push({ fromDate: startDate, toDate: endDate });
      startDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);
    }

    const last12MonthsRanges = [];
  
    thisYearMonthRanges.forEach(({ fromDate }) => {
      const endDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 0);
      const startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 11, 1);
      last12MonthsRanges.push({ fromDate: startDate, toDate: endDate });
    });

    const observablesThisYear = thisYearMonthRanges.map(range =>
      this.dashboardKpiService.getSalesByFields(range.fromDate, range.toDate).pipe(first())
    );
    console.log('lastYearMonthRanges', lastYearMonthRanges)
    const observablesLastYear = lastYearMonthRanges.map(range =>
      this.dashboardKpiService.getSalesByFields(range.fromDate, range.toDate).pipe(first())
    );

    console.log(last12MonthsRanges)
    const observables12Month = last12MonthsRanges.map(range =>
      this.dashboardKpiService.getSalesByFields(range.fromDate, range.toDate).pipe(first())
    );
    
    forkJoin([forkJoin(observables12Month), forkJoin(observablesThisYear), forkJoin(observablesLastYear)]).subscribe(([results, thisYearSales, lastYearSales]) => {

    const twelveMonthTotal = [];
      for (const cat of results) {
        const total12Months = cat[event].totalValue;
        console.log(total12Months)
        twelveMonthTotal.push(total12Months)
      }
    
      const thisYear = [];
      thisYearSales.forEach(thisYearSale => {
        const totalThisYears = thisYearSale[event].totalValue;
        thisYear.push(totalThisYears);
      });
    
      const lastYear = [];
      lastYearSales.forEach(lastYearSale => {
        const totalLastYears = lastYearSale[event].totalValue;
        lastYear.push(totalLastYears);
      });
    
      const labels = [];
      const thisYearLabels = thisYearMonthRanges.map(objeto => `${objeto.fromDate.toLocaleString('en-US', { month: 'long' })} ${objeto.fromDate.getFullYear()}`);
      const lastYearLabels = lastYearMonthRanges.map(objeto => `${objeto.fromDate.toLocaleString('en-US', { month: 'long' })} ${objeto.fromDate.getFullYear()}`);
    
      for (let i = 0; i < 12; i++) {
        const label = [`${lastYearLabels[i]} vs ${thisYearLabels[i]}`];
        labels.push(label);
      }

      this.lineChartLabels = labels;
      this.data.push(thisYear);
      this.data.push(lastYear);
      this.data.push(twelveMonthTotal);

      this.initChartOptions();
      this.loaded = true;

    });
  }
}
